/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Apr_NInputs */

const en_mk_tut_apr_n = /** @type {(inputs: Mk_Tut_Apr_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An agent cannot skip an approval. The gate is enforced server-side, not merely requested in a text instruction.`)
};

const id_mk_tut_apr_n = /** @type {(inputs: Mk_Tut_Apr_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval tidak bisa dilewati oleh agen. Batasan ini ditegakkan di sisi server, bukan sekadar diminta lewat instruksi teks.`)
};

/**
* | output |
* | --- |
* | "An agent cannot skip an approval. The gate is enforced server-side, not merely requested in a text instruction." |
*
* @param {Mk_Tut_Apr_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_apr_n = /** @type {((inputs?: Mk_Tut_Apr_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Apr_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_apr_n(inputs)
	return en_mk_tut_apr_n(inputs)
});